
import React from 'react';
import styles from '../../styles/home.module.css';

function Footer() {
  return (
      <footer className={styles.Footer}>
      <div className={styles.InFooter}>
        <div className={styles.InF}>
          <div className={styles.InFLeft}>
            <ul className={styles.UlF}>
              <li>
                <h2>Podjetje</h2>
              </li>
              <li className={styles.LiF}>
                  <a className="" id="ab" href="#about">O aplikaciji</a>
              </li>
              <li className={styles.LiF}>
                  <a className="" id="ex" href="#expirience">Kaj nudi</a>
              </li>
              <li className={styles.LiF}>
                  <a className="" id="ed" href="#new">Novosti</a>
              </li>
            </ul>
            <ul className={styles.UlF}>
              <li>
                <h2>Podpora</h2>
              </li>
              <li className={styles.LiF}>
                <a className="" id="ed" href="#new">Faq</a>
              </li>
              <li className={styles.LiF}>
                <a className="" id="ed" href="#expirience">Kontaktirajte nas</a>
              </li>
            </ul>
            <ul className={styles.UlF}>
              <li>
                <h2>Prenesi</h2>
              </li>
              <li className={styles.LiF}>
                <img className={styles.ImageD} src={require('../../images/DownloadAndroid.png')} alt="facebook" />
              </li>
              <li className={styles.LiF}>
                <img className={styles.ImageD} src={require('../../images/downloadApple.png')} alt="twitter" />
              </li>
            </ul>
          </div>
          <div className={styles.InFRight}>
            <ul className={styles.UlFIcons}>
              <li className={styles.LiF}>
                <img className={styles.ImageF} src={require('../../icons/facebook.svg')} alt="facebook" />
              </li>
              <li className={styles.LiF}>
                <img className={styles.ImageF} src={require('../../icons/twitter.svg')} alt="twitter" />
              </li>
              <li className={styles.LiF}>
                <img className={styles.ImageF} src={require('../../icons/instagram.svg')} alt="instagram" />
              </li>
            </ul>
          </div>
          
        </div>
        <div className={styles.Pravice}>
          <p>© 2020 Zdravko, Vse pravice pridržane.</p> 
        </div>
        </div>
      </footer>
  );
}

export default Footer;
